import Image from "next/image";
import clsx from "clsx";
import Button from "/components/Button";
import RichText from "./RichText";
import { urlFor } from "/lib/sanity";

export default function ContentBlock({ block }) {
  const hasImage = !!block?.image;
  let href = "#";
  if (block.cta?.linkType === "external") {
    href = block.cta.externalUrl;
  } else if (block.cta?.linkType === "internal") {
    href = block.cta.internalUrl;
  }

  return (
    <div
      className={clsx(
        "flex flex-col md:flex-row md:items-stretch items-center md:items-start",
        hasImage && "bg-brand-secondary",
        !hasImage && "md:px-10 lg:px-12",
        block.reverse && "md:flex-row-reverse"
      )}
    >
      <div
        className={clsx(
          "w-full md:w-1/2 relative md:h-auto",
          hasImage && "h-72 lg:min-h-[480px]"
        )}
      >
        {hasImage && (
          <Image
            src={urlFor(block.image).auto("format").quality(80).url()}
            alt={block.image.alt || ""}
            fill
            sizes="(min-width: 768px) 50vw, 100vw"
            className="object-cover"
          />
        )}
        {!hasImage && (
          <h2 className="text-2xl sm:text-3xl font-bold mb-2">
            {block.heading}
          </h2>
        )}
      </div>

      <div
        className={clsx(
          "w-full md:w-1/2 md:px-10 lg:px-12 sm:text-left",
          hasImage && "px-4 py-4 md:py-10 lg:py-12 self-center"
        )}
      >
        {block.heading && hasImage && (
          <h2 className="text-2xl sm:text-3xl font-bold mb-2">
            {block.heading}
          </h2>
        )}
        {block.body && (
          <RichText
            className="mb-6 text-gray-700 leading-relaxed"
            value={block.body}
          />
        )}
        {block.cta?.label && href && (
          <Button href={href}>{block.cta.label}</Button>
        )}
      </div>
    </div>
  );
}
